import {getheaders} from "./authService";

async function readJson(response, fallback) {
    const body = await response.json().catch(() => null);
    if (!response.ok) throw new Error(body?.message || fallback);
    return body;
}

function catalogRequest(path, method = 'GET', body) {
    return fetch(`/api/worker-settings/${path}`, {
        method,
        headers: getheaders(),
        redirect: 'follow',
        ...(body === undefined ? {} : {body: JSON.stringify(body)}),
    });
}

export async function getWorkerCatalogs() {
    const [skills, serviceAreas, durationTypes] = await Promise.all([
        catalogRequest('skills').then(response => readJson(response, 'Failed to load Skills')),
        catalogRequest('service-areas').then(response => readJson(response, 'Failed to load Service Areas')),
        catalogRequest('duration-types').then(response => readJson(response, 'Failed to load Duration Types')),
    ]);
    return {skills, serviceAreas, durationTypes};
}

export async function getWorkerProfileCatalogs() {
    const [skills, serviceAreas] = await Promise.all([
        catalogRequest('skills').then(response => readJson(response, 'Failed to load Skills')),
        catalogRequest('service-areas').then(response => readJson(response, 'Failed to load Service Areas')),
    ]);
    return {skills, serviceAreas};
}

export function createSkill(value) { return catalogRequest('skills', 'POST', value); }
export function updateSkill(id, value) { return catalogRequest(`skills/${id}`, 'PUT', value); }
export function createServiceArea(value) { return catalogRequest('service-areas', 'POST', value); }
export function updateServiceArea(id, value) { return catalogRequest(`service-areas/${id}`, 'PUT', value); }
export function createDurationType(value) { return catalogRequest('duration-types', 'POST', value); }
export function updateDurationType(id, value) { return catalogRequest(`duration-types/${id}`, 'PUT', value); }

export {readJson as readWorkerSettingsJson};
